import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { getOptimXBackgroundStyle, getProductImage, getProductObjectFit } from '../../../../catalog/Website';
import { context } from '../../../../globalState/GlobalState';
import './css/ProductThumbnail1.css';
import { showPriceFromCents } from '../../../../catalog/Price';
import { DEFAULT_RIBBONS } from '../../../../catalog/Store';
import { isValidObject } from '../../../../catalog/Validity';

const ProductThumbnail1 = (props) => {
    const { product } = props;
    const { globalState } = useContext(context);

    const isOutOfStock = () => {
        return !product.inStock || product.productsTotal - product.productsSold - product.productsHold <= 0;
    };

    const getTotalPriceAndShippingPrice = () => {
        let price = 0;
        if (isValidObject(product.price)) {
            price += product.price;
        }
        if (isValidObject(product.shippingPrice)) {
            price += product.shippingPrice;
        }
        return price;
    };

    return (
        <React.Fragment key={product.id}>
            {product.linked ? (
                <a key={product.id} href={product.url} className={`product-thumbnail1-container text-no-underline ${isOutOfStock() ? 'disable' : ''}`} rel="noreferrer">
                    <div key={product.id} className="product-thumbnail1-image-container">
                        <img className={`product-thumbnail1-image ${isOutOfStock() ? 'disable' : ''}`} src={getProductImage(globalState, product.images)} alt="product" style={{ objectFit: getProductObjectFit(globalState, product.images) }} />
                        {!isOutOfStock() ? (
                            <>
                                {product.ribbons.length > 0 ? <div className="product-thumbnail1-tag" style={getOptimXBackgroundStyle(globalState)}>{DEFAULT_RIBBONS[product.ribbons[0]]}</div> : null}
                                <div className="product-thumbnail1-hover">
                                    <button type="button" className="product-thumbnail1-view-button" style={getOptimXBackgroundStyle(globalState)}>View</button>
                                </div>
                            </>
                        ) : null}
                    </div>
                    <p className="product-thumbnail1-name text-no-underline">{product.title}</p>
                    {isOutOfStock() ? <p className="product-thumbnail1-price text-no-underline">OUT OF STOCK</p> : <p className="product-thumbnail1-price text-no-underline">{showPriceFromCents(getTotalPriceAndShippingPrice())}</p>}
                </a>
            ) : (
                <NavLink key={product.id} to={`/products/${product.id}`} className={`product-thumbnail1-container text-no-underline ${isOutOfStock() ? 'disable' : ''}`}>
                    <div key={product.id} className="product-thumbnail1-image-container">
                        <img className={`product-thumbnail1-image ${isOutOfStock() ? 'disable' : ''}`} src={getProductImage(globalState, product.images)} alt="product" style={{ objectFit: getProductObjectFit(globalState, product.images) }} />
                        {!isOutOfStock() ? (
                            <>
                                {product.ribbons.length > 0 ? <div className="product-thumbnail1-tag" style={getOptimXBackgroundStyle(globalState)}>{DEFAULT_RIBBONS[product.ribbons[0]]}</div> : null}
                                <div className="product-thumbnail1-hover">
                                    <button type="button" className="product-thumbnail1-view-button" style={getOptimXBackgroundStyle(globalState)}>View</button>
                                </div>
                            </>
                        ) : null}
                    </div>
                    <p className="product-thumbnail1-name text-no-underline">{product.title}</p>
                    {isOutOfStock() ? <p className="product-thumbnail1-price text-no-underline">OUT OF STOCK</p> : <p className="product-thumbnail1-price text-no-underline">{showPriceFromCents(getTotalPriceAndShippingPrice())}</p>}
                </NavLink>
            )}
        </React.Fragment>
    );
};

ProductThumbnail1.propTypes = {
    product: PropTypes.object.isRequired,
};

export default memo(ProductThumbnail1);
